module.exports = __webpack_public_path__ + "media/images/zipRecruiter_icon-e7b4776675e836347893dfcc9950875e.png";